// Types.ts
export const REDUCER_NAME = "apkBuildSlice";

export interface iCreateBuildDTO {
  name: string;
  domain: string;
  color: string;
  email: string;
  logo: File | null;
  apptype: string;
  subType: string;
}

export interface iApkBuildState {
  isLoading: boolean;
  buildResponse: any | null;
  errorMessage: string | null;
}
